import { merge } from '@inpart-io/devtools';
import { DataObjectsManager, type IDataObject } from '@inpart-io/devtools-iap';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { padmeConfig } from '@inpart-io/padme-iap';

import { getSearchModule } from '@/store/base/search/module';

import { store } from '..';

const GROUPED_INDEX_MODULE = 'groupedindex';

const groupedIndexManager = DataObjectsManager.getAllDataObjectsManagerInstance(padmeConfig);
const dataObjectModule = getDataObjectsModule<IDataObject>(groupedIndexManager, 5);
const searchModule = getSearchModule<IDataObject>(groupedIndexManager);

const groupedIndexModuleInstance = merge<unknown>(dataObjectModule, searchModule);
store.registerModule(GROUPED_INDEX_MODULE, groupedIndexModuleInstance);

export { GROUPED_INDEX_MODULE };
